<template>
	<div>
		<b-modal ref="confirm" :title="this.title" @hidden="onClick(0)">
			<label class="w-100 text-center">
				<p class="confirmationMessage mt-1">
					<slot></slot>
				</p>
			</label>

			<div slot="modal-footer" class="w-100 text-center">
				<button class="btn btn-dark btn_width btn-style mr-2" @click="onClick(1)">{{ this.buttonYes }}</button>
				<button class="btn btn-secondary btn_width btn-style ml-2" @click="onClick(0)">{{ this.buttonNo }}</button>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import Vue from 'vue';

	export default {
		name: 'ConfirmDialog',
		props: {
			title: {
				type: String
			}
		},
		data () {
			return {
				buttonYes: Vue.i18n.translate('misc.yes'),
				buttonNo: Vue.i18n.translate('misc.no'),
			}
		},
		methods: {
			onClick (but) {
				this.$emit('buttonClick', but);
			},
			show () {
				this.$refs.confirm.show();
			},
			hide () {
				this.$refs.confirm.hide();					
			}
		}
	}
</script>

<style scoped>
	.btn-style {
		width: 20%;
	}
	.confirmationMessage {
		font-size: 16px;
		margin: 0;
	}
</style>
<style scoped src="@/assets/css/button.css" rel="stylesheet"></style>



// WEBPACK FOOTER //
// src/components/global/modals/ConfirmDialog.vue